export const TOTAL_SICK_LEAVES = 10;
export const TOTAL_PRIVILEGED_LEAVES = 15;
